import Container from '@/components/base/Container'
import Image from '@/components/base/Image'
import ImageParallax from '@/components/base/ImageParallax'
import YoutubeVideo from '@/components/base/YoutubeVideo'

import { Section, WPImage } from '@/types'

type MediaProps = Section &
  Partial<{
    use_video: boolean
    video_id: string
    poster: WPImage
    image: WPImage
  }>

const Media = ({
  use_video,
  video_id,
  poster,
  image,
  ...props
}: MediaProps) => {
  return (
    <section {...props}>
      <Container className="relative">
        <div className="aspect-h-[270] aspect-w-[350] md:aspect-h-[315] md:aspect-w-[560]">
          {use_video ? (
            <YoutubeVideo videoId={video_id} poster={poster} autoplay={false} />
          ) : (
            <ImageParallax fill className="rounded-xs">
              {(ref) => (
                <Image
                  fill
                  ref={ref}
                  size="large"
                  loading="lazy"
                  source={image}
                  alt={image?.alt}
                  className="rounded-xs"
                />
              )}
            </ImageParallax>
          )}
        </div>
      </Container>
    </section>
  )
}

export default Media
